import React from 'react';
import { View, StyleSheet } from 'react-native';

import { COLOR, __WEB__ } from '../../../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { openCaseInfo } from '../../../cases/actions';

import { OPComponent, I18n, Utils, Navigation, HeaderItem } from '../../../components';

import CaseSearchEmployer from '../../case_search_employer';

import ListRow, { PATIENT_TYPE_WIDTH, NAME_WIDTH } from './list_row';

class PeopleListMedRecruiter extends OPComponent {
  constructor(props) {
    super(props);
    this.state = {
      toggleToRefreshSearch: false,
    };
  }

  renderItem = ({ item }) => {
    return (
      <ListRow data={item.item} index={item.index} handleResidentTap={this.handleResidentTap} />
    );
  };

  handleResidentTap = (caseId) => {
    Utils.trackEvent('Action', 'Select', 'Open Resident', caseId);

    this.props.actions.openCaseInfo(caseId);
    Navigation.openScreen(
      {
        screen: 'CaseInfo',
        passProps: {
          onCloseScreen: this.handleModalClosed,
        },
      },
      this.props.componentId,
      true
    );
  };

  handleAddResident = () => {
    Navigation.showModal({
      screen: 'CaseForm',
      title: I18n.ac('case.newCase'),
      passProps: {},
    });
  };

  handleModalClosed = (edited) => {
    if (edited) {
      this.setState({ toggleToRefreshSearch: !this.state.toggleToRefreshSearch });
    }
  };

  _renderHeaderNative() {
    const { sortColumn, sortDir } = this.state;
    return (
      <View style={styles.header}>
        <HeaderItem
          label={I18n.ac_aec('employer.resident')}
          name="name"
          style={{ flex: 1 }}
          left={true}
        />
      </View>
    );
  }
  _renderHeaderWeb() {
    const { sortColumn, sortDir } = this.state;
    return (
      <View style={styles.header}>
        <HeaderItem
          label={I18n.ac_aec('employer.resident')}
          name="name"
          style={{ width: NAME_WIDTH, flexGrow: 0.4, flexShrink: 1 }}
        />
        <HeaderItem
          label={'Type'}
          name="patientType"
          style={{ width: PATIENT_TYPE_WIDTH, flexGrow: 0.1, flexShrink: 1 }}
        />
      </View>
    );
  }
  renderHeader = () => {
    return __WEB__ ? this._renderHeaderWeb() : this._renderHeaderNative();
  };

  render() {
    const props = this.props;
    return (
      <CaseSearchEmployer
        confirmationOpts={this.state.confirmationOpts}
        toggleToRefreshSearch={this.state.toggleToRefreshSearch}
        renderItem={this.renderItem}
        renderHeader={this.renderHeader}
        handleAddResident={this.handleAddResident}
        searchLabel={I18n.ce_aec('searchResidents')}
      />
    );
  }
}

const styles = StyleSheet.create({
  header: {
    height: 45,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: COLOR.altContrast,
    borderColor: COLOR.altAccent,
    borderTopWidth: 1,
    borderBottomWidth: 1,
  },
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ openCaseInfo }, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(PeopleListMedRecruiter);
